import Tooltip from "rc-tooltip";
import "./rc-tooltip-reset.scss";
import { TooltipProps, TooltipRef } from "rc-tooltip/lib/Tooltip";

/**
 * @override by rc-tooltip
 * @param props 
 * @returns 
 */
export default function RcToolTip(props: TooltipProps & React.RefAttributes<TooltipRef>) {
  const { showArrow = false, ...other } = props;

  return <Tooltip showArrow={showArrow} {...other} />;
}